import { useRouter } from 'next/router';

/**
 * Hook pour déterminer si le language picker doit être affiché sur la page actuelle
 * @param currentPath Chemin actuel (optionnel, si non fourni, utilise router.asPath)
 * @returns boolean indiquant si le language picker doit être affiché
 */
export function useLanguagePickerVisibility(currentPath?: string) {
  const router = useRouter();

  const path = currentPath || router.asPath || '/';

  return path === '/' || path.startsWith('/lp/') || path === '/contact';
}
